import pubSub from "../utility/pub-sub";
import filterButtonsTemplate from "./filter-buttons.template";
import { AvailableFilter } from "./top-search.interface";
import FilterButtons from "./filter-buttons";

export default (
  onFilterChanged: () => {},
) => {
  let availableFilters: AvailableFilter[] = [];
  const filterButtonWrapper = document.getElementById('js-filter-buttons');

  pubSub.subscribe('availableFilters', (data) => {
    availableFilters = data.data;
  });
  pubSub.subscribe('activeCategory', (data) => {
    filterButtonWrapper.innerHTML = filterButtonsTemplate(availableFilters, data.data);
  });

  const observer = new MutationObserver(mutationRecords => {

    mutationRecords[0].addedNodes.forEach((item) => new FilterButtons(
      (item as HTMLButtonElement),
      onFilterChanged
    ));
  });
  observer.observe(filterButtonWrapper, {
    childList: true, // observe direct children
    subtree: true, // and lower descendants too
    characterDataOldValue: true // pass old data to callback
  });
}
